import { render } from "./ViewSimulation.vue?vue&type=template&id=2fb2887a&scoped=true&ts=true"
import script from "./ViewSimulation.vue?vue&type=script&lang=ts"
export * from "./ViewSimulation.vue?vue&type=script&lang=ts"

import "./ViewSimulation.vue?vue&type=style&index=0&id=2fb2887a&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb2887a"]])

export default __exports__